module.exports = __webpack_public_path__ + "413e81aeac11a095304f3452050b5988.jpg";